export default __webpack_public_path__ + "static/media/dodajobr.2f52ce06.jpg";